import { IconButton, Paper, Stack, Typography } from '@mui/material'
import { Delete } from '@mui/icons-material'
import React from 'react'
import { com } from '@eidu/web'
import EntitySelector = com.eidu.sharedlib.entity.selector.EntitySelector
import EntityType = com.eidu.sharedlib.entity.type.EntityType

import SelectorEditor from './SelectorEditor'
import { SelectorType } from './SelectorType'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

type NotProps = {
  selector: EntitySelector.Not
  entityTypes: readonly EntityType[]
  onChange: (newSelector: EntitySelector) => void
  selectorType: SelectorType
  lockedEntityTypeId?: EntityTypeId
}

const NotSelector: React.FC<NotProps> = ({ selector, entityTypes, onChange, selectorType, lockedEntityTypeId }) => (
  <Paper
    variant="outlined"
    sx={{
      borderColor: 'blue',
      borderStyle: 'dotted',
      borderRadius: 1,
    }}
  >
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography variant="caption" color="blue">
        NOT
      </Typography>
      <IconButton onClick={() => onChange(selector.selector)}>
        <Delete color="error" />
      </IconButton>
    </Stack>
    <SelectorEditor
      selector={selector.selector}
      onChange={(newSel) => onChange(new EntitySelector.Not(newSel))}
      entityTypes={entityTypes}
      selectorType={selectorType}
      lockedEntityTypeId={lockedEntityTypeId}
    />
  </Paper>
)

export default NotSelector
